// @flow
import Add from './Add';
import DishesAddButton from './DishesAddButton';

export default Add;
export { DishesAddButton };
